import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import _ from 'lodash';
import cx from 'classnames';

import { Widget, WidgetsContext } from "../../core";
import { useWidgetSelector } from '../../core/hooks';

import { BackgroundView } from '../../background';

import styles from './loading.module.scss';

const LoadingView = function LoadingWidget({ className, style, widgetProps, breakpoint, children }) {
  const id = _.get(widgetProps, 'uid');
  const type = _.get(widgetProps, 'type');

  const stretched = _.get(widgetProps, 'properties.desktop.stretched', false);
  const parent = _.get(widgetProps, 'parent');
  const background = _.get(widgetProps, 'properties.desktop.background');

  const widgetStyles = {
    ...style,
    marginLeft: 0
  };

  return (
    <div
      id={id}
      style={widgetStyles}
      className={cx(className, styles.loaderSection, 'widget')}
      data-widget-id={id}
      data-widget-type={type}
    >
      <BackgroundView background={background} breakpoint={breakpoint} />
      {children}
    </div>
  )
};

const LoadingWidget = React.forwardRef((props, ref) => {
  return <LoadingView {...props} ref={ref} />
});

export { LoadingWidget };
